import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { filterTag_template } from "./filterTag_template";
import { filterTagType_template } from "./filterTagType_template";

declare var ko: any;

export class filterDataset_template extends vnTemplate {
    protected tagFilter: filterTag_template;
    protected tagTypeFilter: filterTagType_template;

    static SINGLE_SELECTION_MODE: string = 'single';
    static MULTIPLE_SELECTION_MODE: string = 'multiple';

    protected datasetContainerId: string = 'selected-dataset';
    protected datasetContainerCaption: string = 'Selected Dataset:';

    protected getTemplateHtml(): string {

        return `<div class="dataset-filter">
                    <div class="w-spec-search icon i-auto-complete i-tag-a">
                        <input data-bind="textInput: dataset, event: { keyup: onChangeInput}, disable: idDataset() != null, valueUpdate : 'afterkeydown', attr:{id:idDataset}" placeholder="Dataset" list="datasets" class="input-text" style="min-width: 168px;">
                            <ul class="form-auto-list" data-bind="foreach: datasets, visible: isShowDatasetSuggestions, attr : {id: idFilter() + '-dataset'}" >
                                <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.name, click: $parent.onBlurDataset" ></li>
                            </ul>
                        </input>
                        <button data-bind="event: { click: onClearInput }, attr: { id: idFilter() + '-input-close'}" class="close-btn icon i-x-after" type="button"><span class="hidden-text">close</span></button>
                    </div>
                    <div data-bind="visible: isDataTypeDropdownVisible">
                        <select data-bind="options: dataTypeOptions, value: selectedTagType, optionsValue: 'id', optionsText: 'name', optionsCaption: 'All', event: { change : onSelectTagType }">
                        
                    </div>
                </div>
                `;
    }

    protected getTemplateName(): string {
        return "filterDataset-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected initPartial() {
        this.getTemplateViewModel().idFilter(this.idElement);
        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.asMultipleSelectionMode();
        this.tagTypeFilter = new filterTagType_template("tagTypeFilter", this.getTemplateViewModel(), this.caller);
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return {
            selectionMode:ko.observable(filterDataset_template.SINGLE_SELECTION_MODE),
            datasets: ko.observableArray([]),
            idDataset: ko.observable(null),
            idFilter: ko.observable(),
            idTagType: ko.observable(null),
            dataset: ko.observable(""),
            datasetObj: ko.observable(null),
            datasetObjs: ko.observableArray(null),
            orderBy: "name",
            orderByDirection: "ASC",
            isShowDatasetSuggestions: ko.observable(false),
            isDataTypeDropdownVisible: ko.observable(false),
            dataTypeOptions: ko.observableArray(['all']),
            dataType: ko.observable(null),
            selectedTagType: ko.observable(0),
            onChangeInput: (data, event): void => {
                self.onChangeInput(data, event);
            },
            onClearInput: (data, event): void => {
                self.onClearInput(event);
            },
            onChangeFilterAction: (data, event): void => {
                self.onChangeFilterAction(data)
            },
            onBlurDataset: (data, event): void => {
                self.onBlurDataset(data, event);
            },
            onSelectTagType: (data): void => {
                self.onSelectTagType(data);
            }
        };
    }

    protected onChangeFilterAction(data) {
        this.caller.filterSimpleOnChange(this.idElement);
    }

    protected onChangeInput(data, event) {
        let input = event.target;
        let inputWrapper = input.parentNode;
        let closeBtn = inputWrapper.querySelector('#' + this.idElement + '-input-close');
        if (!closeBtn.classList.contains('is-showing')) {
            closeBtn.classList.add('is-showing');
        }
        this.onChangeDatasetDataList(event, this.viewModel[this.idElement].idDataset);
        
    }

    protected onChangeDatasetDataList(event, idDataset) {

        let input = event.target,
            inputVal = input.value,
            options: any = document.getElementById(this.idElement + "-dataset").childNodes;
        
        if (inputVal.length >= 2) {
            this.caller.getDatasetSuggestion(inputVal, this.idElement);
            this.getTemplateViewModel().isShowDatasetSuggestions(true);

        }
        for (let op of options) {
            if (op.value === inputVal) {
                idDataset(op.id);
                input.blur();
                this.caller.filterSimpleOnChange(this.idElement);
                break;
            }
        }
    }

    protected onClearInput(event) {
        let button = event.target;
        if (button.classList.contains('is-showing')) {
            button.classList.remove('is-showing');
            this.viewModel[this.idElement].idDataset(null);
            this.viewModel[this.idElement].dataset("");
            this.viewModel[this.idElement].datasets([]);
            this.viewModel[this.idElement].datasetObj("");
            this.viewModel[this.idElement].isShowDatasetSuggestions(false);
            this.viewModel[this.idElement].selectedTagType("");
            this.getTemplateViewModel().idTagType('');
            
            this.caller.filterSimpleOnChange(this.idElement);
            this.getTemplateViewModel().isDataTypeDropdownVisible(false);

            if(this.idElement == "filterDataset"){
                document.getElementById("filterTagType").style.display = "block";
            }else if(this.idElement == "datasetFilter"){
                document.getElementById("tagTypeFilter").style.display = "block";
            }

        }
    }

    public clearInput() {
        let button = document.getElementById(this.idElement + "-input-close");
        if (button.classList.contains('is-showing')) {
            button.classList.remove('is-showing');
        }
        this.setIdDataset(null);
        this.setDataset('');
        this.setDatasets([]);
        this.setDatasetObj('');
        this.setIsShowDatasetSuggestions(false);
        this.tagTypeFilter.setTagTypeObjs([]);
        this.tagTypeFilter.setTagTypeObj('');
        this.tagTypeFilter.setTagType(null);
        this.getTemplateViewModel().idTagType('');
    }

    protected onBlurDataset(data, event) {

        this.setDataset(data.name);
        this.setDatasetObj(data);
        this.setIdDataset(data.id);

        this.handleSelectionModeSpecific(data);

        this.setDatasets([]);
        this.setIsShowDatasetSuggestions(false);
        if(this.caller.name != 'tagTypes'){
            this.caller.deleteAllSelectedTagType();
        }
        this.caller.filterSimpleOnChange(this.idElement);

        if(this.caller.name != "tagTypes"){
            this.getDatasetDropdownOptions(data.id);
            this.getTemplateViewModel().isDataTypeDropdownVisible(true);
        } 

    }

    protected onSelectTagType(data) {

        let selectedTagType = this.getTemplateViewModel().selectedTagType();

        this.getTemplateViewModel().idTagType(selectedTagType);
        this.tagTypeFilter.getTemplateViewModel().tagTypes([{'id':selectedTagType}]);

        this.caller.filterSimpleOnChange(this.idElement);
    }

    private handleSelectionModeSpecific(data): void {

        if (this.isMultipleSelectionMode()) {
            if (this.getDatasetObjs().length == 0) {
                this.addCaption();
            }
            this.appendTagToSelection(data);
            //this.clearInput();
        } else {
            this.replaceTagInSelection(data);
        }
    }

    private appendTagToSelection(dataset): void {
        let datasetObjs = this.getDatasetObjs();
        let filtered = datasetObjs.filter((t) => t.id == dataset.id);
        if (filtered.length == 0) {

            datasetObjs.push(dataset);
            this.addHtmlTag(dataset);
            this.setDatasetObjs(datasetObjs);
        }
    }


    private removeDatasetFromSelection(datasetId): void {
        let datasets = this.getDatasetObjs().filter((tt) => tt.id != datasetId);
        this.setDatasetObjs(datasets);
    }

    private replaceTagInSelection(dataset): void {
        this.setDatasetObjs([]);
        this.setDatasetObjs([dataset]);
    }

    public asMultipleSelectionMode(): void {
        this.setSelectionMode(filterDataset_template.MULTIPLE_SELECTION_MODE);
    }

    public isMultipleSelectionMode(): boolean {
        return this.isSelectionMode(filterDataset_template.MULTIPLE_SELECTION_MODE);
    }

    public isSingleSelectionMode(): boolean {
        return this.isSelectionMode(filterDataset_template.SINGLE_SELECTION_MODE);
    }

    public isSelectionMode(selectionMode: string): boolean {
        return (this.getSelectionMode() == selectionMode);
    }

    public setDatasetContainerId(datasetContainerId: string): void {
        this.datasetContainerId = datasetContainerId;
    }

    public getDatasetContainerId(): string {
        return this.datasetContainerId;
    }

    protected getDatasetContainer()
    {
        return document.getElementById(this.datasetContainerId);
    }


    public resetDatasetContainer(): void {
        if (this.getDatasetContainer()) {
            this.getDatasetContainer().innerHTML = '';
        }
    }

    protected addCaption()
    {
        if (this.getDatasetContainer()) {
            if (!this.hasCaption()) {
                this.getDatasetContainer().appendChild(this.createCaption());
            }
        }
    }


    protected hasCaption(): boolean {

        let captions = this.getDatasetContainer().getElementsByTagName('label');

        return (captions.length > 0);

    }

    protected createCaption()
    {
        let element = document.createElement('label');

        element.setAttribute('class', 'small');
        element.appendChild(document.createTextNode(this.datasetContainerCaption));

        return element;
    }

    protected addHtmlTag(dataset)
    {
        if (this.getDatasetContainer()) {

            this.getDatasetContainer().appendChild(this.createHtmlTag(dataset));
        }
    }

    protected createHtmlTag(dataset)
    {
        let self = this;

        let element = document.createElement('button');

        element.setAttribute('id', dataset.id);
        element.appendChild(document.createTextNode(dataset.name));
        element.setAttribute('class', 'btn-f-s icon i-x-after');
        element.setAttribute('type', 'button');

        element.addEventListener('click', function (e) {

            // @ts-ignore
            self.removeDatasetFromSelection(e.target.getAttribute('id'));
            // @ts-ignore
            self.getDatasetContainer().removeChild(e.target);
            if (self.getDatasetObjs().length == 0) {
                self.resetDatasetContainer();
            }

            self.caller.filterSimpleOnChange(self.idElement);
        }, false);

        return element;
    }

    public setDatasetContainerCaption(datasetContainerCaption: string): void {
        this.datasetContainerCaption = datasetContainerCaption;
    }

    public getTagContainerCaption(): string {
        return this.datasetContainerCaption;
    }

    public setDatasetInfo(dataset){

        if(dataset) {
            this.setDataset(dataset.name + ' ' + dataset.formattedDataset);
            this.setDatasetObj(dataset);
            this.setIdDataset(dataset.id);
            this.setDatasets([]);
            this.setIsShowDatasetSuggestions(false);
        } else {
            this.setDataset('');
            this.setDatasetObj('');
            this.setIdDataset(null);
            this.setDatasets([]);
            this.setIsShowDatasetSuggestions(false);
        }
    }

    public toggleCloseButton(): void {

        let closeBtn = document.getElementById(this.idElement + '-input-close');
        let idTag = this.getTemplateViewModel().idDataset();

        if (idTag == null) {
            closeBtn.classList.remove('is-showing');
        } else {
            closeBtn.classList.add('is-showing');
        }
    }
    public setSelectionMode(selectionMode): void {
        this.getTemplateViewModel().selectionMode(selectionMode);
    }

    public getSelectionMode() {
        return this.getTemplateViewModel().selectionMode();
    }

    public setDatasets(datasets): void {
        this.getTemplateViewModel().datasets(datasets);
    }

    public getDatasets() {
        return this.getTemplateViewModel().datasets();
    }

    public setIdDataset(idDataset): void {
        this.getTemplateViewModel().idDataset(idDataset);
    }

    public getIdDataset() {
        return this.getTemplateViewModel().idDataset();
    }

    public setIdFilter(idFilter): void {
        this.getTemplateViewModel().idFilter(idFilter);
    }

    public getIdFilter() {
        return this.getTemplateViewModel().idFilter();
    }

    public setDataset(dataset): void {
        this.getTemplateViewModel().dataset(dataset);
    }

    public getDataset() {
        return this.getTemplateViewModel().dataset();
    }

    public setDatasetObj(datasetObj): void {
        this.getTemplateViewModel().datasetObj(datasetObj);
    }

    public getDatasetObj() {
        return this.getTemplateViewModel().datasetObj();
    }
    public setDatasetObjs(datasetObjs): void {
        this.getTemplateViewModel().datasetObjs(datasetObjs);
    }

    public getDatasetObjs() {
        return this.getTemplateViewModel().datasetObjs();
    }

    public setOrderBy(orderBy): void {
        this.getTemplateViewModel().orderBy = orderBy;
    }

    public getOrderBy() {
        return this.getTemplateViewModel().orderBy;
    }

    public setOrderByDirection(orderByDirection): void {
        this.getTemplateViewModel().orderByDirection = orderByDirection;
    }

    public getOrderByDirection() {
        return this.getTemplateViewModel().orderByDirection;
    }

    public setIsShowDatasetSuggestions(isShowDatasetSuggestions): void {
        this.getTemplateViewModel().isShowDatasetSuggestions(isShowDatasetSuggestions);
    }

    public getIsShowDatasetSuggestions() {
        return this.getTemplateViewModel().isShowDatasetSuggestions();
    }

    public getDatasetsForRequest() {
        let datasets = this.getDatasetObjs();
        if (!datasets || datasets.length == 0) {
            return null;
        }
        return datasets.map((t) => {
           return {id: t.id, name: t.name};
        });
    }

    public setSelectedItems(datasets): void {
        if (datasets && datasets.length > 0) {
            if (this.isMultipleSelectionMode()) {
                this.addCaption()
            }
            datasets.forEach((tT) => {
                this.appendTagToSelection(tT);
            });
        }
    }


    public getDatasetDropdownOptions(id) {
        if(this.idElement == "filterDataset"){
            document.getElementById("filterTagType").style.display = "none";
        }else if(this.idElement == "datasetFilter"){
            document.getElementById("tagTypeFilter").style.display = "none";
        }
        this.caller.getTagTypeByDatasetId(id);
    
    }

    
}



// WEBPACK FOOTER //
// ./js/components/templates/filterDataset_template.ts